var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.11101 13.8203C5.26216 14.5895 6.61553 15 8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.61553 14.5895 5.26216 13.8203 4.11101C13.0511 2.95987 11.9579 2.06266 10.6788 1.53285C9.3997 1.00303 7.99224 0.86441 6.63437 1.13451C5.2765 1.4046 4.02922 2.07129 3.05026 3.05026C2.07129 4.02922 1.4046 5.2765 1.13451 6.63437C0.86441 7.99224 1.00303 9.3997 1.53285 10.6788C2.06266 11.9579 2.95987 13.0511 4.11101 13.8203ZM4.66658 3.01119C5.65328 2.3519 6.81332 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8C14 9.18669 13.6481 10.3467 12.9888 11.3334C12.3295 12.3201 11.3925 13.0892 10.2961 13.5433C9.19975 13.9974 7.99335 14.1162 6.82946 13.8847C5.66558 13.6532 4.59648 13.0818 3.75736 12.2426C2.91825 11.4035 2.3468 10.3344 2.11529 9.17054C1.88378 8.00666 2.0026 6.80026 2.45673 5.7039C2.91085 4.60755 3.67989 3.67047 4.66658 3.01119ZM7.5 8.205L10.295 11L11 10.295L8.5 7.79V3.5H7.5V8.205Z",
    fill: "#6D747D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.13f21056b6e0459156d74727dbbbbc1a.svg";
export { ForwardRef as ReactComponent };